import React, { useEffect, useState, useRef } from "react";
import classes from "./ChangeApproval.module.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer, Eye } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Accordion, Tab, Tabs, Row, Col, Popover, Table } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
// import AdminNav from "../AdminHeaderNav/AdminNav";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaCalendarCheck } from "react-icons/fa";
import { FaCalendarXmark } from "react-icons/fa6";
import HeaderNav from "../../Budget/Budget Dashboard/HeaderNav/HeaderNav";






const ChangeApproval = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedRadio, setSelectedRadio] = useState("");

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currLoading, setCurrLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [user, setUser] = useState('');
  const [loanBen,  setLoanBen] = useState([]);
const [roleLoading, setRoleLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState('');
  const [showPay, setShowPay] = useState(false);
  const handleClosePay = () => setShowPay(false);
  // const handleShowPay = () => setShowPay(false);
  const handleShowPay = () => setShowPay(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);
  const [userProvinces, setUserProvinces] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");

  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  // const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);
  const [currency, setCurrency] = useState([]);
  const payment = location.state?.payment;
   const [searchedResult, setSearchedResult] = useState([]);
 const [searchLoading, setSearchLoading] = useState(false);
   const [tableData1, setTableData1] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
     const [show2, setShow2] = useState(false);
      const [tableData4, setTableData4] = useState([]);
        const [loading, setLoading] = useState(false);
          const [tableData5, setTableData5] = useState([]);
        const [selectedProvinces, setSelectedProvinces] = useState([]);
     const [selectedContinent, setSelectedContinent] = useState(null);
 const handleShow = (user) => {
    setSelectedUser(user); // Set the selected user data
    setShow(true); // Show the modal
  };
    const handleClose2 = () => {
    setTableData5([]);  // Clear the provinces data when closing the modal
    setSelectedProvinces([]);  // Clear the provinces data when closing the modal
    setShow2(false);     // Close the modal
  };

  const handleShow1 = (user) => {
    setSelectedUser(user); // Set the selected user data
    setShow2(true); // Show the modal
  };
  
const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    username: "",
    role: "",
    password: "",
    confirmPassword: "",
  });

  // Permissions state
  const [permissions, setPermissions] = useState({
    "User Management": { view: true, create: true, edit: false, delete: false, approve: false },
    Finance: { view: true, create: false, edit: false, delete: false, approve: true },
    Reports: { view: true, create: false, edit: false, delete: false, approve: false },
    Settings: { view: true, create: false, edit: true, delete: false, approve: false },
    Providers: { view: true, create: false, edit: true, delete: false, approve: false },
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle checkbox change
  const handleCheckboxChange = (module, perm) => {
    setPermissions((prev) => ({
      ...prev,
      [module]: { ...prev[module], [perm]: !prev[module][perm] },
    }));
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("User Data:", formData);
    console.log("Permissions:", permissions);
    // You can add API call here
    handleClose(); // close modal after submission
  };
 const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }
  const selectedUserProvinces = selectedUser?.assigned_provinces.map((item) => ({
    label: item.province_name,
    value: item.province_id,
  }));

   const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion(null);
    // setSelectedProvinces([]);
  };
    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('tobi');
  
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
        } else {
          navigate('/login');
          return;
        }
  
        if (value1 !== null) {
          setUser(value1);
        }
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);


      const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


    const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };
  const handleSelectedUserProvinceChange = (e, province) => {
  const isChecked = e.target.checked;

  if (isChecked) {
    // Add province to userProvinces if it isn't already present
    setUserProvinces((prev) => {
      // Prevent duplicates and add the current one
      if (!prev.some((p) => p.value === province.value)) {
        return [...prev, { value: province.value, label: province.label }];
      }
      return prev; // Return unchanged if already present
    });
  } else {
    // If unchecked, remove the province from userProvinces
    setUserProvinces((prev) =>
      prev.filter((p) => p.value !== province.value)
    );
  }
};
  const createUser1 = async () => {
    setLoading(true);
    const mergedProvinces = [
      ...userProvinces.map((province) => province.value),
      // ...userProvinces.map((province) => province.value),
    ];
  
    try {
      const response = await axios.post(
        `${BASE_URL}/deassign-compliance-from-province`,
        {
         user_id: selectedUser?.user_id,
         province_id: mergedProvinces
        },
        { headers }
      );
      console.log(response);
      fetchData();
      handleClose2();
      
      // return
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      console.log(response.data);
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  };
    const createUser = async () => {
    setLoading(true);
    const mergedProvinces = [
      ...selectedProvinces.map((province) => province.value),
      // ...userProvinces.map((province) => province.value),
    ];
  
    try {
      const response = await axios.post(
        `${BASE_URL}/assign-compliance-to-province`,
        {
         user_id: selectedUser?.user_id,
         province_id: mergedProvinces
        },
        { headers }
      );
      console.log(response);
      fetchData();
      setSelectedProvinces([]);
      handleClose();
      
      // return
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      console.log(response.data);
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  };

 const handleProvinceChange = (e, province) => {
  const checked = e.target.checked;
  if (checked) {
    // Add province to selectedProvinces if not already present
    setSelectedProvinces((prev) => {
      if (!prev.some((p) => p.value === province.value)) {
        return [...prev, { value: province.value, label: province.label }];
      }
      return prev; // If it's already present, return unchanged
    });
  } else {
    // Remove province from selectedProvinces
    setSelectedProvinces((prev) => prev.filter((p) => p.value !== province.value));
  }
};
    const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  // const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);

   const fetchData = async () => {
    setRoleLoading(true);
    try {
      //?page=${currentPage}
      const response = await axios.get(
        `${BASE_URL}/provinces/get-approved-initiated-working-month?page=${currentPage}`,
        { headers }
      );
      console.log(response, "WORKING MONTH ...")
      const results = response.data?.data?.data || [];
      const totalEntries = response.data?.data?.total || 0;
  
      setTableData(results);
      setTotalEntries(totalEntries);
      setTotalPages(response.data?.data?.last_page || 1);
    } catch (error) {
      console.error("Fetch Data Error:", error);
      setTableData([]); // Clear table on error
    } finally {
      setRoleLoading(false);
    }
  };


  
  // const fetchSearch = async () => {
  //   setSearchLoading(true);
  //   try {
  //     let res;
  //     if (searchTerm.trim() === "") {
  //       res = tableData1;
  //     } else {
  //       const response = await axios.get(`${BASE_URL}/users/search`, {
  //         params: { variable: searchTerm },
  //         headers
  //       });
  //       res = response.data?.data;
  //     }
  //     setSearchedResult(res);
  //     console.log(res);

  //   } catch (error) {
  //     if (error.response && error.response.status === 401) {
  //       navigate('/login');
  //     } else {
  //       let errorMessage = 'An error occurred. Please try again.';
  //       if (error.response && error.response.data && error.response.data.message) {
  //         if (typeof error.response.data.message === 'string') {
  //           errorMessage = error.response.data.message;
  //         } else if (Array.isArray(error.response.data.message)) {
  //           errorMessage = error.response.data.message.join('; ');
  //         } else if (typeof error.response.data.message === 'object') {
  //           errorMessage = JSON.stringify(error.response.data.message);
  //         }
  //         console.log(error);
  //       }
  //       setSearchedResult([]);
  //     }
  //   } finally {
  //     setSearchLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchSearch()
  // },[searchTerm])


  useEffect(() => {
    if (bearer) {
      fetchData();
    }
  }, [bearer, currentPage]);

      const handleTrashClick = async (uuid) => {
        const confirmed = await Swal.fire({
          title: 'Are you sure?',
          text: 'You are about to delete this payment.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel',
        });
    
        if (!confirmed.isConfirmed) {
          return; // User canceled, do nothing
        }
    
        try {
          const response = await axios.get(`${BASE_URL}/payments/delete_perm?uuid=${uuid}`, { headers });
          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });
          fetchData();
          // setTrashClicked(true);
        } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
              if (error.response && error.response.data && error.response.data.message) {
                  if (typeof error.response.data.message === 'string') {
                      errorMessage = error.response.data.message;
                  } else if (Array.isArray(error.response.data.message)) {
                      errorMessage = error.response.data.message.join('; ');
                  } else if (typeof error.response.data.message === 'object') {
                      errorMessage = JSON.stringify(error.response.data.message);
                  }
            Swal.fire({
              imageUrl: crop,
              imageWidth: 48,
              imageHeight: 48,
              title: "Failed!",
              confirmButtonText: "Okay",
              text: JSON.stringify(error.response.data.message),
              customClass: {
                title: classes.myTitle,
                popup: classes.myText,
                confirmButton: classes.myDeclineButton,
              },
              allowOutsideClick: false, // Prevent closing by clicking outside
              preConfirm: () => {
                Swal.close(); // Explicitly close the modal
              },
            });
        }
        }
      };

// const handlePrint = (id) => {
//   navigate("/print_payments", {
//     state: { invoice: tableData },
//   });
// };

const handlePrint = (uuid) => {
  const selectedInvoice = tableData.find((item) => item.uuid === uuid);
  if (selectedInvoice) {
    navigate("/print_payments", {
      state: { invoice: selectedInvoice },
    });
  }
};

  const fetchCurrency1 = async () => {
    setCurrLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
      const results = response.data?.data;
        // console.log(results, "currencis")
      const options = results.map((item) => ({
        label: item.code,
        value: item.id,
        symbol: item.symbol,
        country: item.country
      }));
      setCurrency(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCurrency([]);
    } finally {
        setCurrLoading(false);
    }
  };
// currency
  useEffect(() => {
    if (bearer) {
        fetchCurrency1();
    }
}, [bearer]);

  const fetchLoanBen = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers-select`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        // bank: item.bank_name,
        value: item.id,
      }));
      console.log(response , "loan Benf");
      setLoanBen(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoanBen([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchLoanBen();
    }
  }, [bearer]);


  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },  
    ]);
  };

  
  const fetchMode = async () => {
       
    try {
        const response = await axios.get(`${BASE_URL}/income/get-payment-method`, { headers });
        const results = response.data?.data;
        setPaymentModes(results);
    } catch (error) {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
      setPaymentModes([]);
    } finally {
        
    }
};

    useEffect(() => {
      if (bearer) {
        fetchMode();
      }
    }, [bearer]);

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;
  // 1. **Determine the data to render (Before the tbody)**
// const dataToRender = (searchTerm && searchedResult.length > 0)
//     ? searchedResult
//     : tableData;

    const filteredData = tableData.filter(item =>
        item.province_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      const dataToRender = searchTerm.trim()
        ? filteredData
        : tableData;
      

// 2. **Check for no results (After determining dataToRender)**
const isNoResults = !roleLoading && dataToRender.length === 0;
  const handleApprove = async (id) => {
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to approve this`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Approve it!',
      cancelButtonText: 'No, Cancel',
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }

    // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
    Swal.fire({
      title: 'Approving...',
      text: 'Please wait while your request is being processed.',
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the confirm button
      didOpen: () => {
        Swal.showLoading(); // Show loading spinner
      }
    });
    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/approve-working-month`,
        {
          id: id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`,
          },
        }
      );

      // Display success message
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      fetchData();
      console.log(response.data);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
    }
  };

  return (
    <div>
      <HeaderNav />


      <div className={classes.Container}>
      <Modal show={show} onHide={handleClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Assign Provinces to {selectedUser?.user_name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form style={{ marginBottom: 20 }}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
                        <Form.Label>Continent</Form.Label>
                        <Select
                          onChange={(selectedOption) =>
                            handleContinentChange(selectedOption)
                          }
                          options={selectOptions}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "300px",
                              maxWidth: "450px",
                              overflowY: "auto",
                            }),
                          }}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-1">
                        <Form.Label>Region</Form.Label>
                        <Select
                          onChange={(selectedOption) =>
                            handleRegionChange(selectedOption)
                          }
                          options={tableData4}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "300px",
                              maxWidth: "450px",
                              overflowY: "auto",
                            }),
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                
                  <div style={{ marginTop: 10 }} />

<Accordion >
  <Accordion.Item >
    <Accordion.Header>Assigned Provinces</Accordion.Header>
    <Accordion.Body>
    <div className="row">
  {selectedUserProvinces && selectedUserProvinces.length > 0 ? (
  selectedUserProvinces.map((province) => {
    // Determine if the province is checked based on userProvinces state
    // const isChecked = userProvinces.some((p) => p.value === province.value);

    return (
      <div key={province.value} className="col-md-4 mb-3">
        <label className="d-flex align-items-center">
          {/* <input
            type="checkbox"
            value={province.value}
            className="me-2"
           
            onChange={(e) => handleSelectedUserProvinceChange(e, province)} // Handle checkbox change
          /> */}
          <span>{province.label}</span>
        </label>
      </div>
    );
  })
) : (
  <p>No provinces have been assigned to this user. Please select a continent and region to start with.</p>
)}


      </div>
    </Accordion.Body>
  </Accordion.Item>
  <Accordion.Item >
<Accordion.Header>Assign User to Province</Accordion.Header>
<Accordion.Body>
<div className="row">
{selectedProvinces && selectedProvinces.length > 0 && (
        <>
          <h6 style={{fontWeight: 700}}>Selected Provinces</h6>
          {selectedProvinces.map((province) => (
            <div key={province.value} className="col-md-4 mb-3">
              <label className="d-flex align-items-center">
                <input
                  type="checkbox"
                  value={province.value}
                  className="me-2"
                  checked={true}
                  onChange={(e) => handleProvinceChange(e, province)} // Pass the whole object
                />
                {/* Display the label stored in selectedProvinces */}
                <span>{province.label}</span>
              </label>
            </div>
          ))}
          <hr /> {/* Separator between selected and unselected provinces */}
        </>
      )}
      <div style={{marginTop: 10}}/>
      <h6 style={{fontWeight: 700}}>Provinces</h6>
      {tableData5 && tableData5.length > 0 ? (
  tableData5.map((province) => {
    // Determine if this province is selected
    const isSelected = selectedProvinces.some((p) => p.value === province.value);

    return (
      <div key={province.value} className="col-md-4 mb-3">
        <label className="d-flex align-items-center">
          <input
            type="checkbox"
            value={province.value}
            className="me-2"
            checked={isSelected} // Reflect the selectedProvinces state here
            onChange={(e) => handleProvinceChange(e, province)} // Handle checkbox change
          />
          <span>{province.label}</span>
        </label>
      </div>
    );
  })
) : (
  <p>No provinces to display. Please select a continent and region to start with.</p>
)}
      </div>
                  </Accordion.Body>
                  </Accordion.Item>
</Accordion>



             


                </Form>
                <Modal.Footer>
              <Button variant="light" onClick={handleClose}>
                Go back
              </Button>
              <Button variant="success" onClick={createUser} className={classes.btnss}>
                {loading ? (
                  <>
                    <Spinner size="sm" />
                    <span style={{ marginLeft: "5px" }}>
                      Saving Changes, Please wait...
                    </span>
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Modal.Footer>



         
              </Modal.Body>
            
            </Modal>
            
            <Modal show={show2} onHide={handleClose2} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Unassign Provinces </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form style={{ marginBottom: 20 }}>
                
                  <div style={{ marginTop: 10 }} />

<Accordion >
  <Accordion.Item >
    <Accordion.Header>Assigned Provinces</Accordion.Header>
    <Accordion.Body>
    <div className="row">
  {selectedUserProvinces && selectedUserProvinces.length > 0 ? (
  selectedUserProvinces.map((province) => {
    // Determine if the province is checked based on userProvinces state
    const isChecked = userProvinces.some((p) => p.value === province.value);

    return (
      <div key={province.value} className="col-md-4 mb-3">
        <label className="d-flex align-items-center">
          <input
            type="checkbox"
            value={province.value}
            className="me-2"
            // checked={isChecked} // Check based on userProvinces state
            onChange={(e) => handleSelectedUserProvinceChange(e, province)} // Handle checkbox change
          />
          <span>{province.label}</span>
        </label>
      </div>
    );
  })
) : (
  <p>No provinces have been assigned to this user. Please select a continent and region to start with.</p>
)}


      </div>
    </Accordion.Body>
  </Accordion.Item>
</Accordion>



             


                </Form>
                <Modal.Footer>
              <Button variant="light" onClick={handleClose2}>
                Go back
              </Button>
              <Button variant="success" onClick={createUser1} className={classes.btnss}>
                {loading ? (
                  <>
                    <Spinner size="sm" />
                    <span style={{ marginLeft: "5px" }}>
                      Saving Changes, Please wait...
                    </span>
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Modal.Footer>



         
              </Modal.Body>
            
            </Modal>


        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>


        <header className={classes.Header}>
          <h2 className={classes.Title}>Approve Working Month</h2>
          {/* <h1 className={classes.Titles}>
          View and approve changed working month requests
          </h1> */}
        </header>


        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search Province"  value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
            </div>
    
          </div>
          <div className={classes.actionsLeft}>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr style={{ fontSize: "12px" }}>
                  <th style={{width: "5%"}}>S/N</th>
                  <th style={{width: "30%"}}>Province Name</th>
                  <th style={{width: "15%"}}>Last Date</th>
                  <th style={{width: "15%"}}>Current Date</th>
                  <th style={{width: "15%"}}>Date Approved</th>
                  <th style={{width: "15%"}}>Approved By</th>
                  <th style={{width: "30%"}}>Status</th>
                  {/* <th>Post Date</th> */}
                  <th style={{width: "7%"}}>Actions</th>
                </tr>
              </thead>
              <tbody>
  {roleLoading
    ? // 1. LOADING SKELETON
      Array(5)
        .fill()
        .map((_, idx) => (
          <tr key={idx}>
            {Array(8)
              .fill()
              .map((_, i) => (
                <td key={i}>
                  <Skeleton height={20} style={{ marginBottom: 10 }} />
                </td>
              ))}
          </tr>
        ))
    : isNoResults ? (
      // 2. NO RESULTS MESSAGE
      <tr>
        <td colSpan={7} style={{ textAlign: "center" }}> 
          {/* Use 7 if your columns are 7, or adjust `colSpan` */}
          {searchTerm ? "No results found for your search." : "No province found."}
        </td>
      </tr>
    ) : (
      // 3. RENDER DATA (from dataToRender)
      dataToRender.map((item, index) => (
        <tr key={item.id} style={{ fontSize: "12px" }}>
          <td>{index + 1}</td>
          <td style={{ textWrap: 'nowrap' }}>{item.province_name}</td>
        <td style={{ width: 50 }}>{item.current_date}</td>
           <td>{item.intending_date}</td>
        <td>{item.approved_date}</td>
         <td>{item.approved_by_name || item.disapproved_by_name}</td>
        <td style={{ display: "flex", width: 100, justifyContent: "center", alignItems: "center" }}>
                            {item.status === "1" ? (
                              <div
                                style={{
                                  height: 15,
                                  width: 80,
                                  border: "1px solid #50b848",
                                  borderRadius: 3,
                                  color: "#50b848",
                                  fontSize: 10,
                                  textAlign: "center",
                                  fontWeight: 700
                                }}
                              >
                                APPROVED
                              </div>
                            ) : item.status === "2" ? (
                              <div
                                style={{
                                  height: 15,
                                  width: 80,
                                  border: "1px solid #dc3545",
                                  borderRadius: 3,
                                  color: "#dc3545",
                                  fontSize: 10,
                                  textAlign: "center",
                                  fontWeight: 700
                                }}
                              >
                                DISAPPROVED
                              </div>
                            ) :  item.status === "0" && item.progress_direction === "1" ? (
                              <div
                                style={{
                                  height: 15,
                                  width: 80,
                                  border: "1px solid #ffc107",
                                  borderRadius: 3,
                                  color: "#ffc107",
                                  fontSize: 10,
                                  textAlign: "center",
                                  fontWeight: 700
                                }}
                              >
                                INITIATED
                              </div>
                            ): 
                            <div
                                style={{
                                  height: 15,
                                  width: 80,
                                  border: "1px solid #078fffffff",
                                  borderRadius: 3,
                                  color: "#078fffffff",
                                  fontSize: 10,
                                  textAlign: "center",
                                  fontWeight: 700
                                }}
                              >
                                REVERSED
                              </div>
                            }
                          </td>
         <td style={{ padding: 5 }}>
                          {item.status !== '1' && item.status !== '2' && (
                              <>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id="button-tooltip">Click to approve this changed working month</Tooltip>}
                                >
                                  <FaCalendarCheck onClick={() => handleApprove(item.id)} style={{ height: 22, color: "#2d995f", cursor: 'pointer', }} />

                                </OverlayTrigger>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id="button-tooltip">Click to disapprove this working month</Tooltip>}
                                >
                                  <FaCalendarXmark style={{ height: 22, color: "#dc3545", cursor: 'pointer', marginLeft: 10 }} onClick={() => handleShow(item.id)} />

                                </OverlayTrigger>
                              </>
                            )}
                          </td>
        </tr>
      ))
    )}
</tbody>
            </table>


          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button                   
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return(
                <button className={classes.active}  key={page + 1}
                style={{
                  color: page + 1 === currentPage ? '#ffffff' : '#000',
                  backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                  cursor: "pointer",
                  marginLeft:5
                }}
                onClick={() => setCurrentPage(page + 1)}
              > {page + 1}
              </button>
                    );
                  }
                  return null;
                })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
          </div>


        </div>
      </div>
     
      {/* <Footer /> */}
    </div>
  );
};

export default ChangeApproval;
